import { TextField } from '@mui/material';
export const PrimaryInput = (props) => {
  return (
    <TextField
      variant="outlined"
      {...props}
      slotProps={{
        input: {
          endAdornment: props.error ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
            >
              <circle cx="9" cy="9" r="9" fill="#FF2D2D" />
              <path
                d="M9 4.09082V10.2272M9 13.0908V13.4999"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </svg>
          ) : (
            <></>
          ),
        },
      }}
      sx={{
        borderRadius: '4px',
        background: 'white',
        maxHeight: '48px',
        border: props?.error ? '1px solid #FF2D2D' : '',
        '& .MuiInputBase-root': {
          width: '100%',
          height: '100%',
          padding: '13px',
          overflow: 'hidden',
        },
        '& .Mui-focused': {
          border: props?.error ? '' : '1px solid #44546A',
          boxShadow: '0px 0px 0px 4px rgba(0, 0, 0, 0.15)',
        },
        '& .MuiInputBase-input': {
          color: '#44546A',
          fontSize: '16px',
          lineHeight: '21px',
          fontWeight: '700',
          border: 'none',
          textAlign: 'center',
        },
        '& .MuiOutlinedInput-root': {
          '& fieldset': {
            border: 'none',
          },
          '&:hover fieldset': {
            border: 'none',
          },
          '&.Mui-focused fieldset': {
            border: 'none',
          },
        },
        '& .MuiInputBase-input::placeholder': {
          color: '#44546A',
          opacity: 0.5,
          fontSize: '16px',
          lineHeight: '21px',
          fontWeight: '500',
          fontStyle: 'italic',
          textAlign: 'left',
        },
        ...props?.sx,
      }}
      {...props.otherProps}
    />
  );
};
